import { apiClient } from "@/lib/api-client"
import { FolderInfoDto } from "../entities/FolderInfoDto"
import { FolderContentsDto } from "../entities/FolderContentsDto"
import { FolderTreeDto } from "../entities/FolderTreeDto"

export interface CreateFolderRequest {
  name: string
  parentFolderId?: string | null
}

export interface RenameFolderRequest {
  name: string
}

export const folderService = {
  createFolder: async (
    organizationId: string,
    data: CreateFolderRequest,
  ): Promise<FolderInfoDto> => {
    const response = await apiClient.post<FolderInfoDto>(
      `/organizations/${organizationId}/document-folders`,
      data,
    )
    return response.data
  },

  getFolder: async (
    organizationId: string,
    id: string,
  ): Promise<FolderInfoDto> => {
    const response = await apiClient.get<FolderInfoDto>(
      `/organizations/${organizationId}/document-folders/${id}`,
    )
    return response.data
  },

  listFolders: async (
    organizationId: string,
    parentFolderId?: string,
  ): Promise<FolderInfoDto[]> => {
    const response = await apiClient.get<FolderInfoDto[]>(
      `/organizations/${organizationId}/document-folders`,
      { params: parentFolderId ? { parentFolderId } : undefined },
    )
    return response.data
  },

  getFolderContents: async (
    organizationId: string,
    id: string,
  ): Promise<FolderContentsDto> => {
    const response = await apiClient.get<FolderContentsDto>(
      `/organizations/${organizationId}/document-folders/${id}/contents`,
    )
    return response.data
  },

  getFolderTree: async (organizationId: string): Promise<FolderTreeDto[]> => {
    const response = await apiClient.get<FolderTreeDto[]>(
      `/organizations/${organizationId}/document-folders/tree`,
    )
    return response.data
  },

  renameFolder: async (
    organizationId: string,
    id: string,
    data: RenameFolderRequest,
  ): Promise<FolderInfoDto> => {
    const response = await apiClient.put<FolderInfoDto>(
      `/organizations/${organizationId}/document-folders/${id}`,
      data,
    )
    return response.data
  },

  deleteFolder: async (organizationId: string, id: string): Promise<void> => {
    await apiClient.delete(
      `/organizations/${organizationId}/document-folders/${id}`,
    )
  },
}
